import { render, staticRenderFns } from "./10b_doc.vue?vue&type=template&id=15498234&scoped=true"
import script from "./10b_doc.vue?vue&type=script&lang=js"
export * from "./10b_doc.vue?vue&type=script&lang=js"
import style0 from "./10b_doc.vue?vue&type=style&index=0&id=15498234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15498234",
  null
  
)

export default component.exports